import { useCallback, useRef, useState } from 'react';

const useResizeObserver = () => {
  const observerRef = useRef<ResizeObserver>();
  const [resizeParameters, setResizeParameters] = useState({
    width: 0,
    height: 0,
    clientWidth: 0,
    clientHeight: 0,
    scrollWidth: 0,
    scrollHeight: 0,
  });

  const handleResize = useCallback((entries: ResizeObserverEntry[]) => {
    if (!Array.isArray(entries)) return;

    const entry = entries[0];

    setResizeParameters({
      width: entry?.contentRect.width ?? 0,
      height: entry?.contentRect.height ?? 0,
      clientWidth: entry?.target.clientWidth ?? 0,
      clientHeight: entry?.target.clientHeight ?? 0,
      scrollWidth: entry?.target.scrollWidth ?? 0,
      scrollHeight: entry?.target.scrollHeight ?? 0,
    });
  }, []);

  const ref = useCallback(
    (node: HTMLElement | null) => {
      if (observerRef.current && !node) {
        observerRef.current.disconnect();
        observerRef.current = undefined;
      }

      if (!observerRef.current && node) {
        observerRef.current = new ResizeObserver(handleResize);
        observerRef.current.observe(node);
      }
    },
    [handleResize]
  );

  return [ref, resizeParameters] as const;
};

export default useResizeObserver;
